/**
 * @desc 审批
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: defs.wms.FrozenCreateOrderApprovalDto, options?: any) {
  return updateResponse(
    http(URL + `/wms/frozenCreateOrder/approval`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
